import { useQuery } from 'react-query';
import { MasterOrganization } from 'v2/models';
import restFactory from 'v2/utils/restFactory';

export function useMasterOrganization() {
  return useQuery('masterOrganization', async () => {
    const masterOrganization = await restFactory.get<MasterOrganization[]>(
      `/dj/api/v1/master_organization/`
    );
    return masterOrganization[0];
  });
}
